/* JWL CART — free-shipping progress track. Rationale: docs/jwl-cart-build.md -> "JS notes" */
(function () {
  function ensureParts(el) {
    var message = el.querySelector('.jwl-shipping-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'jwl-shipping-message';
      el.insertBefore(message, el.firstChild);
    }

    /* icon + theme placeholder start as direct children; order matters — see docs */
    var icon = el.querySelector('.jwl-shipping-row__icon');
    if (icon && icon.parentElement !== message) {
      message.insertBefore(icon, message.firstChild);
    }

    var placeholder = el.querySelector('.text-subdued');
    if (placeholder && placeholder.parentElement !== message) {
      message.appendChild(placeholder);
    }

    var track = el.querySelector('.jwl-shipping-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'jwl-shipping-track';
      track.appendChild(document.createElement('span'));
      el.insertBefore(track, message.nextSibling);
    }

    /* track-end icon moved once; position is pure CSS — see docs */
    var trackIcon = el.querySelector('.jwl-shipping-track__icon');
    if (trackIcon && trackIcon.parentElement !== track) {
      track.appendChild(trackIcon);
    }

    return track;
  }

  function update(el) {
    var track = ensureParts(el);
    var fill = track.querySelector('span');
    var threshold = parseFloat(el.getAttribute('threshold')) || 0;
    var total = parseFloat(el.getAttribute('total-price')) || 0;
    var qualified = threshold > 0 && total >= threshold;
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    fill.style.width = pct + '%';
    track.classList.toggle('jwl-shipping-track--qualified', qualified);
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(update);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price', 'threshold'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();

/* JWL CART — gift threshold. Adds and removes the free-gift line for qualifying carts.
   Markup and the qualifying logic live in snippets/jwl-cart-gift-threshold.liquid; this only carries out the
   decision that snippet has already made, so there is exactly one place where "qualifies" is defined. */
(function () {
  var busy = false;
  var request = null;
  var failedState = '';
  var letCheckoutThrough = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function stateOf(el) {
    return ['gift-variant', 'qualifies', 'gift-in-cart', 'gift-line-key', 'gift-quantity']
      .map(function (name) { return el.getAttribute(name); })
      .join('|');
  }

  /* Resolves true once the drawer has re-rendered with the change (cart-drawer:refreshed), false if that has not
     happened within 5s -- the refresh itself failed, and the markup on the page is still the old one. */
  function refreshDrawer() {
    return new Promise(function (resolve) {
      var settled = false;
      function finish(ok) {
        if (settled) return;
        settled = true;
        document.removeEventListener('cart-drawer:refreshed', onRefreshed);
        resolve(ok);
      }
      function onRefreshed() { finish(true); }
      document.addEventListener('cart-drawer:refreshed', onRefreshed);
      setTimeout(function () { finish(false); }, 5000);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  /* One gift change at a time, and the lock lasts until the drawer has re-rendered with the result -- not a fixed
     800ms. Evaluating before that reads the OLD attributes and fires a duplicate; ignoring everything until the
     next DOM change (as the timed lock did) missed changes made while it was held. So it evaluates once more when
     the lock lifts, against the fresh markup.
     A change that fails -- an HTTP error now counts, it used to pass as success -- is not retried while the cart is
     in the same state, so a refused add cannot loop; the next real cart change clears it. */
  function mutate(el, path, body) {
    var state = stateOf(el);
    busy = true;
    request = fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error('gift change returned ' + response.status);
    });

    request
      .then(function () {
        failedState = '';
        return refreshDrawer().then(function (refreshed) {
          if (!refreshed) failedState = state;
        });
      }, function () {
        failedState = state;
      })
      .then(function () {
        request = null;
        busy = false;
        evaluate();
      });
  }

  function evaluate() {
    if (busy) return;

    var el = document.querySelector('jwl-gift-threshold');
    if (!el) return;
    if (failedState && stateOf(el) === failedState) return;

    var variantId = parseInt(el.getAttribute('gift-variant'), 10);
    if (!variantId) return;

    var qualifies = el.getAttribute('qualifies') === 'true';
    var inCart = el.getAttribute('gift-in-cart') === 'true';
    var lineKey = el.getAttribute('gift-line-key');
    var quantity = parseInt(el.getAttribute('gift-quantity'), 10) || 0;

    if (qualifies && !inCart) {
      mutate(el, 'cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      return;
    }

    if (!qualifies && inCart && lineKey) {
      mutate(el, 'cart/change.js', { id: lineKey, quantity: 0 });
      return;
    }

    /* One gift per cart, whatever the shopper does with the quantity stepper. */
    if (qualifies && inCart && quantity > 1 && lineKey) {
      mutate(el, 'cart/change.js', { id: lineKey, quantity: 1 });
    }
  }

  /* Checkout pressed while a gift change is still on its way to Shopify: hold it until that request has finished
     (at most 4s), so the order is placed on the cart the shopper was shown. Only the request is waited for, not
     the drawer re-render -- checkout reads the cart from Shopify, not from the page. */
  document.addEventListener('submit', function (event) {
    if (!request || letCheckoutThrough) {
      letCheckoutThrough = false;
      return;
    }
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    event.preventDefault();
    var form = event.target;
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 4000); });
    Promise.race([request.catch(function () {}), timeout]).then(function () {
      letCheckoutThrough = true;
      if (form.requestSubmit) {
        form.requestSubmit(submitter);
      } else {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        input.value = submitter.value || '';
        form.appendChild(input);
        letCheckoutThrough = false;
        form.submit();
      }
    });
  }, true);

  function start() {
    evaluate();
    new MutationObserver(evaluate).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['qualifies', 'gift-in-cart', 'gift-quantity', 'gift-variant'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();

/* JWL CART — hide the chat widget while the cart drawer is open.
   The CSS rule in jwl-cart-studio-light.css handles this on its own when it matches. This is the backstop for
   when it does not: Shopify Inbox is an app-injected widget whose host element name and inline styles are
   outside our control and have changed before, so matching it by name alone is not something to rely on. */
(function () {
  var BY_NAME = [
    'shopify-chat',
    '[id*="shopify-chat" i]',
    '[class*="shopify-chat" i]',
    'iframe[src*="shopify-chat"]',
    'iframe[title*="chat" i]',
  ].join(',');

  var hidden = [];

  /* Falls back to body-level fixed elements stacked above the page when nothing matches by name. Chat widgets
     sit at the very top of the stacking order (z-index in the millions); the theme's own fixed furniture does
     not, which is what keeps the header and the drawer itself out of this. */
  function candidates() {
    var byName = [].slice.call(document.querySelectorAll(BY_NAME));
    if (byName.length) return byName;

    var drawer = document.getElementById('cart-drawer');
    return [].filter.call(document.body.children, function (el) {
      if (drawer && (el === drawer || el.contains(drawer))) return false;
      if (/^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) return false;
      var cs = getComputedStyle(el);
      return cs.position === 'fixed' && (parseInt(cs.zIndex, 10) || 0) >= 1000;
    });
  }

  function hide() {
    if (hidden.length) return;
    candidates().forEach(function (el) {
      hidden.push([el, el.style.getPropertyValue('display'), el.style.getPropertyPriority('display')]);
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function show() {
    hidden.forEach(function (entry) {
      var el = entry[0];
      if (entry[1]) el.style.setProperty('display', entry[1], entry[2]);
      else el.style.removeProperty('display');
    });
    hidden = [];
  }

  function sync() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.hasAttribute('open')) hide();
    else show();
  }

  function start() {
    sync();
    new MutationObserver(sync).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
